import type { OrderActivityKind, OrderActivityLogListItem } from '@/models/OrderActivityLog';
import type { Component } from 'vue';
import {
  ArrowPathIcon,
  BoltIcon,
  BuildingOffice2Icon,
  CalendarDaysIcon,
  ChatBubbleLeftRightIcon,
  CheckCircleIcon,
  ClipboardDocumentListIcon,
  CubeIcon,
  CurrencyDollarIcon,
  DocumentTextIcon,
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  FlagIcon,
  InboxIcon,
  LinkIcon,
  MapPinIcon,
  PencilIcon,
  PhotoIcon,
  ShieldCheckIcon,
  TruckIcon,
  UserIcon,
  UserGroupIcon,
} from '@heroicons/vue/24/solid';

/**
 * Icon for each order activity log row, aligned with status metaphors used in OrderTimeline.vue.
 */
export function getActivityLogListIcon(log: OrderActivityLogListItem): Component {
  const k = log.activity_kind;
  if (k) {
    const byKind: Record<OrderActivityKind, Component> = {
      factory_assigned: BuildingOffice2Icon,
      factory_edited: BuildingOffice2Icon,
      asana_template: ClipboardDocumentListIcon,
      activity_flow: ArrowPathIcon,
      sample_upload: PhotoIcon,
      sample_status: PhotoIcon,
      customer_sample_action: UserIcon,
      sample_rejected_reupload: ExclamationCircleIcon,
      third_party_approval: ShieldCheckIcon,
      put_in_production: CubeIcon,
      production_date_change: CalendarDaysIcon,
      shipping_details: TruckIcon,
      shipping_address_my_task: MapPinIcon,
      qc_tracking_link: LinkIcon,
      dropdown_status: ClipboardDocumentListIcon,
      reorder: ArrowPathIcon,
      delivery_box: InboxIcon,
      details_tab_update: PencilIcon,
      order_admin_assigned: UserGroupIcon,
      order_copied_without_admin: ExclamationTriangleIcon,
      urgency_updated: ExclamationTriangleIcon,
      custom_pdf: DocumentTextIcon,
      internal_comment: ChatBubbleLeftRightIcon,
      price_breakdown: CurrencyDollarIcon,
      tech_pack: DocumentTextIcon,
      approval: CheckCircleIcon,
      schedule: CalendarDaysIcon,
      dqc_status: ClipboardDocumentListIcon,
    };
    return byKind[k] ?? DocumentTextIcon;
  }

  const t = (log.activity_type ?? '').toLowerCase();
  if (t.includes('ship') || t.includes('truck')) return TruckIcon;
  if (t.includes('factory') || t.includes('production') || t.includes('cube')) return CubeIcon;
  if (t.includes('approval') || t.includes('approve')) return CheckCircleIcon;
  if (t.includes('schedule') || t.includes('date') || t.includes('calendar')) return CalendarDaysIcon;
  if (t.includes('pdf') || t.includes('doc') || t.includes('file')) return DocumentTextIcon;
  if (t.includes('reject') || t.includes('cancel') || t.includes('error')) return ExclamationCircleIcon;
  if (t.includes('complete') || t.includes('flag')) return FlagIcon;

  return DocumentTextIcon;
}
